import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS } from '../../Button/constants';
import { baseButton } from '../../Button/styles/base.styles';
import { spinnerTransitions } from '../../Button/styles/spinner.styles';

const SMALL_SIZE = 36;
const SMALL_HOVER_SIZE = SMALL_SIZE - 4;
const LARGE_SIZE = 44;
const LARGE_HOVER_SIZE = LARGE_SIZE - 4;
const SPINNER_CLASSNAME_PREFIX = 'ribbons-round-button';

const { fonts, responsiveText } = theme;

const roundButtonStyle = css`
  border-radius: ${pxToRem(6)};
  background-color: transparent;

  .${BUTTON__CONTENT_CLASS} {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    height: ${pxToRem(28)};
    ${responsiveText.BODY.MD}
  }

  &:hover {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 10%, white);

    .${BUTTON__CONTENT_CLASS} {
      color: ${palette.deepPurpleBase};
    }
  }

  &:disabled {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 10%, white);
    cursor: not-allowed;

    .${BUTTON__CONTENT_CLASS} {
      color: ${palette.deepPurpleBase};
    }
  }

  ${spinnerTransitions(SPINNER_CLASSNAME_PREFIX)}
`;

export const roundButtonBase = css`
  ${baseButton}
  ${roundButtonStyle}
`;

export const small = css`
  width: ${pxToRem(SMALL_SIZE)};
  height: ${pxToRem(SMALL_SIZE)};

  &:active {
    transform: scale(${SMALL_HOVER_SIZE / SMALL_SIZE});
  }
`;

export const large = css`
  width: ${pxToRem(LARGE_SIZE)};
  height: ${pxToRem(LARGE_SIZE)};

  &:active {
    transform: scale(${LARGE_HOVER_SIZE / LARGE_SIZE});
  }
`;

export const buttonOverrides = css`
  border-radius: 50%;
  border: none !important;
  padding: 0;

  .${BUTTON__CONTENT_CLASS} {
    display: flex;
    justify-content: center;
  }

  &.focus-visible:focus {
    background-color: var(--neutral-white-base);
  }
`;
